import styles from './style/ModalCategory.module.scss';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MdEditNote } from 'react-icons/md';

import Modal from '../../Utilities/Modal';
import TextField from '../../Utilities/TextField';
import Button from '../../Utilities/Button';
import Table from '../../Utilities/Table';
import { selectIndustries, updateCategory, updateDataIndustries } from '../../../store/slice/language/industries';

const ModalCategory = ({ detail, setDetail, setIsOpen, isOpen, code, setCode }) => {
  const dispatch = useDispatch();
  const { lists } = useSelector(selectIndustries);

  const [error, setError] = useState(false);

  const handleUpdate = () => {
    if (!detail[code?.code]) {
      setError(true);
    } else {
      const array = [];
      lists?.rows?.forEach((item) => {
        array.push({
          id: item.id,
          name: item.name,
          multilingual: item[code?.code],
        });
      });
      const postObj = {
        code: code?.value,
        industries: [
          {
            id: detail.id,
            industry: detail.industry,
            multilingual: detail[code?.code],
            categories: array,
          },
        ],
      };
      dispatch(updateCategory(postObj)).then(() => {
        setIsOpen(false);
        setError(false);
      });
    }
  };

  const handleCancel = () => {
    setDetail('');
    setIsOpen(false);
    setError(false);
  };

  const headerData = [
    {
      title: '產業名稱',
      width: 50,
    },
    {
      title: '原始資料',
      width: 50,
    },
  ];

  const handleChangeList = (value, data) => {
    const array = structuredClone(lists);

    array?.rows?.forEach((item) => {
      if (item.id === data.id) {
        item[code?.code] = value;
      }
    });

    dispatch(updateDataIndustries(array));
  };

  return (
    <>
      <Modal size='xl' isOpen={isOpen}>
        <div className={styles.modalHeader}>
          <div className={styles.modalSubHeader}>
            <div className={styles.modalTitle}>
              <MdEditNote className={styles.modalIcon} />
              編輯產業 <small>（{code?.text}）</small>
            </div>
          </div>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.colHalf}>
            <div className={styles.rightWrapper}>
              <label className={styles.labelTitle}>產業類別</label>
              <TextField
                value={detail[code?.code]}
                onChange={(e) => setDetail({ ...detail, [code?.code]: e })}
                error={error && !detail[code?.code]}
                fullWidth
              />
              {error && !detail[code?.code] && <span className={styles.messageError}>未輸入產業類別</span>}
            </div>
          </div>

          <div className={styles.title}>產業名稱列表</div>
          <Table header={headerData} type={'condensed'}>
            {lists?.total > 0 && (
              <tbody>
                {lists?.rows?.map((data, index) => (
                  <tr key={index}>
                    <td width={`${headerData[0].width}%`}>
                      <input
                        type='text'
                        placeholder=''
                        className='searchInput'
                        onChange={(e) => handleChangeList(e.target.value, data)}
                        value={data[code?.code] ? data[code?.code] : ''}
                        style={{ width: '97%' }}
                      />
                    </td>
                    <td>{data.name}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </div>

        <div className={`${styles.modalFooter} ${styles.right}`}>
          <span style={{ marginRight: '8px' }}>
            <Button type='quaternary' title='取消' onClick={handleCancel} style={{ marginRight: '8px' }} />
          </span>
          <Button type='primary' title='儲存' onClick={handleUpdate} />
        </div>
      </Modal>

      {/* <Toast show={updated} title={'職能項目已更改'} subtitle={`${detail.category} - ${item}`} /> */}
    </>
  );
};

export default ModalCategory;
